import { StoreContext } from 'context'
import { useContext } from 'react'

export const useStores = () => useContext(StoreContext)